module.exports = __webpack_public_path__ + "img/phone-import.85797998.svg";